<template>
  <div id="lm-capture-photo" class="mw-100">
    <div class="row">
      <div class="col-12">
        <div class="position-relative" v-show="showVideoSection">
            <LmComponentLoading v-if="processing" />
            <video v-show="!imageSrc && browserSupportGetUserMedia" ref="videoPlayer" class="mw-100 video-player" autoplay></video>
            <button v-if="!imageSrc && browserSupportGetUserMedia" class="take-photo-button" @click="capture">
              <font-awesome-icon
                class="camera-icon"
                icon="camera-retro"
                size="3x"
                :style="{color: 'white'}"
                />
            </button>
            <div v-if="imageSrc" class="row mt-2 wrapper-button-actions">
              <div class="col-6 justify-content-center d-flex">
                <LmButton
                  type="button"
                  buttonClass="btn-secondary"
                  :value="$t('Cancel')"
                  @click.native="cancel"
                  />
              </div>
              <div class="col-6 justify-content-center d-flex">
                <LmButton
                  type="submit"
                  buttonClass="btn-primary"
                  :value="$t('Save')"
                  @click.native="submit"
                  />
              </div>
            </div>
            <img v-show="imageSrc" :src="imageSrc" ref="imageRef" class="mw-100" alt="">
            <canvas ref="canvasCapture" class="mw-100 h-auto d-block canvas-capture"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import LmButton from '@/components/form/elements/LmButton'
export default {
  data () {
    return {
      imageCapture: '',
      browserSupportGetUserMedia: 'getUserMedia' in navigator.mediaDevices,
      browserSupportImageCapture: typeof ImageCapture === 'function',
      showVideoSection: false,
      player: null,
      canvas: null,
      track: null,
      image: null,
      imageSrc: null,
      imgType: null,
      imgName: null,
      processing: false
    }
  },
  components: {
    LmButton
  },
  methods: {
    closeCamera () {
      if (this.track) {
        this.track.stop()
      }
    },
    cancel () {
      this.imageSrc = ''
    },
    async submit () {
      const res = await fetch(this.imageSrc)
      const blob = await res.blob()
      const file = new File([blob], this.imgName ? this.imgName : 'img-name.png', this.imgType ? { type: this.imgType } : { type: 'image/png' })
      let fd = new FormData()
      fd.append('file', file)
      try {
        this.processing = true
        const response = await axios.post(`${process.env.VUE_APP_API_URL}documentos/nuevo/`, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${store.state.session.accessToken}`
          }
        })
        this.$emit('imageChanged', process.env.VUE_APP_API_URL_STATIC_ASSETS + response.data.path)
        this.closeCamera()
        this.showVideoSection = false
        this.imageSrc = ''
      } catch (error) {
        console.log('error', error)
      } finally {
        this.processing = false
      }
    },
    async capture () {
      if (this.browserSupportImageCapture) {
        const blob = await this.imageCapture.takePhoto()
        this.imageSrc = URL.createObjectURL(blob)
      } else {
        this.canvas.width = this.player.offsetWidth
        this.canvas.height = this.player.offsetHeight
        this.context.drawImage(this.player, 0, 0, this.canvas.width, this.canvas.height)
        this.imageSrc = this.canvas.toDataURL()
      }
      this.$emit('capture', this.imageSrc)
      this.image.width = this.player.offsetWidth
      this.image.height = this.player.offsetHeight
    },
    async getUserMedia () {
      try {
        this.processing = true
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        })
        this.showVideoSection = true
        if (this.browserSupportImageCapture) {
          const mediaStreamTrack = stream.getVideoTracks()[0]
          this.imageCapture = new ImageCapture(mediaStreamTrack)
        }
        this.player.srcObject = stream
        this.track = stream.getVideoTracks()[0]
        return true
      } catch (error) {
        this.showVideoSection = false
        console.log('error', error)
        return false
      } finally {
        this.processing = false
      }
    }
  },
  mounted () {
    this.player = this.$refs.videoPlayer
    this.canvas = this.$refs.canvasCapture
    this.image = this.$refs.imageRef
    this.context = this.canvas.getContext('2d')
  },
  beforeDestroy () {
    this.closeCamera()
  }
}
</script>

<style lang="sass" scoped>
#lm-capture-photo
  .video-player
    display: block
  .take-photo-button
    position: absolute
    width: 100%
    height: 50px
    left: 0
    right: 0
    margin: 0 auto
    background: #8BAF3F
    bottom: 0
    border: none
    border-radius: 0
  .wrapper-button-actions
    position: absolute
    width: 100%
    height: 50px
    left: 0
    right: 0
    margin: 0 auto
    bottom: 0
  .canvas-capture
    position: absolute
    z-index: -10
    left: -100vw
    top: 0
</style>
